import { format, getMilliseconds, isFirstDayOfMonth, isSameYear, subMilliseconds } from "date-fns";

import { DateFormat } from "constants/date";
import { AppStateProvider } from "services/app-state-provider";
import { selectAgentName } from "store/entities/agents";
import { selectTeamName } from "store/entities/teams";
import { hasReportFiltersComparison } from "store/views/reports";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IChartLegend } from "../Chart";

export function getDateRangeLabel(from: Date | string | number, to: Date | string | number): string {
  if (isSameYear(from, to) && isSameYear(new Date(), to)) {
    const adjustedTo = isFirstDayOfMonth(to) && getMilliseconds(to) === 0 ? subMilliseconds(to, 1) : to;
    return `${format(from, DateFormat.DateWithoutYear)}–${format(adjustedTo, DateFormat.DateWithoutYear)}`;
  }

  return `${format(from, DateFormat.ChartDailyRangeLabel)}–${format(to, DateFormat.ChartDailyRangeLabel)}`;
}

export function getMonthRangeLabel(from: Date | string | number, to: Date | string | number): string {
  return `${format(from, DateFormat.ChartMonthlyLabel)}–${format(to, DateFormat.ChartMonthlyLabel)}`;
}

export function getHourRangeLabel(from: Date | string | number, to: Date | string | number): string {
  return `${format(from, DateFormat.TimeWithoutSeconds)}–${format(to, DateFormat.TimeWithoutSeconds)}`;
}

export function defaultNameResolver({ name, filters }: IChartLegend): string[] {
  const state = AppStateProvider.getState();

  const nameParts = [name || ""];

  if (hasReportFiltersComparison(state) && filters) {
    if (filters.dateFrom && filters.dateTo) {
      nameParts.push(getDateRangeLabel(filters.dateFrom as string, filters.dateTo as string));
    }

    if (filters.group) {
      nameParts.push(selectTeamName(state, filters.group as string));
    }

    if (filters.agent) {
      nameParts.push(selectAgentName(state, filters.agent as string));
    }
  }

  return nameParts.filter(Boolean);
}
